var _defs, _style, _path, _g, _path2, _tspan, _tspan2, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRi11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 443 110",
    width: 443,
    height: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "li1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m406.2 37.89h35.87v35.87h-35.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 12.58h82.58v82.58h-82.58z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #ff8206 } \n\t\t.t2 { font-size: 20px;fill: #000000;font-weight: 500;font-family: \"Poppins-Medium\", \"Poppins\" } \n\t\t.s3 { fill: #000000 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    className: "s0",
    d: "m368.5 0h-255.8c-7.2 0-14.3 1.4-21 4.2-6.7 2.7-12.7 6.8-17.8 11.9-5.1 5.1-9.2 11.2-11.9 17.8-2.8 6.7-4.2 13.8-4.2 21 0 7.3 1.4 14.4 4.2 21.1 2.7 6.6 6.8 12.7 11.9 17.8 5.1 5.1 11.1 9.2 17.8 11.9 6.7 2.8 13.8 4.2 21 4.2h255.8q2.5 0 4.9-0.5 2.4-0.6 4.6-1.6 2.2-1 4.1-2.5 2-1.5 3.6-3.4l31.9-38q1.7-2 2.4-4.2 0.9-2.3 0.9-4.8c0-1.6-0.3-3.2-0.9-4.7-0.5-1.5-1.3-3-2.4-4.2l-31.9-38q-1.6-1.9-3.6-3.4-1.9-1.5-4.1-2.5-2.2-1-4.6-1.6-2.4-0.5-4.9-0.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Clip-Path: Group_819",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    className: "s1",
    d: "m442.1 55.8c0 7.3-4.4 13.8-11.1 16.6-6.7 2.8-14.4 1.2-19.5-3.9-5.2-5.1-6.7-12.8-3.9-19.5 2.7-6.7 9.3-11.1 16.5-11.1 2.4 0 4.7 0.4 6.9 1.4 2.2 0.9 4.2 2.2 5.8 3.8 1.7 1.7 3 3.7 3.9 5.9 0.9 2.1 1.4 4.5 1.4 6.8z"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    className: "s0",
    d: "m432.1 55.8c0 3.2-1.9 6.2-4.9 7.4-3 1.2-6.4 0.5-8.7-1.7-2.3-2.3-3-5.7-1.7-8.7 1.2-3 4.1-4.9 7.3-4.9q1.6 0 3.1 0.6 1.4 0.6 2.6 1.7 1.1 1.1 1.7 2.6 0.6 1.4 0.6 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Enhances_vendor_collaboration"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Improves Procurement ",
    style: {
      transform: "matrix(1,0,0,1,113.078,53.665)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t2"
  }, "Improves Procurement \n"))), /*#__PURE__*/React.createElement("text", {
    id: "Supply Chain operations",
    style: {
      transform: "matrix(1,0,0,1,113.078,75.665)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t2"
  }, "Supply Chain operations\n")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Clip-Path: Group_816",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    className: "s1",
    d: "m82.6 53.9c0 16.7-10.1 31.7-25.5 38.1-15.4 6.4-33.2 2.9-45-8.9-11.8-11.8-15.3-29.6-9-45 6.4-15.5 21.5-25.5 38.2-25.5 5.4 0 10.8 1 15.8 3.1 5 2.1 9.6 5.1 13.4 9 3.8 3.8 6.9 8.4 8.9 13.4 2.1 5 3.2 10.3 3.2 15.8z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    className: "s0",
    d: "m68.2 54.2c0 10.7-6.5 20.4-16.4 24.5-10 4.1-21.4 1.9-29-5.7-7.6-7.6-9.9-19.1-5.8-29 4.1-9.9 13.8-16.4 24.6-16.4 3.5 0 6.9 0.7 10.2 2 3.2 1.3 6.1 3.3 8.6 5.8 2.5 2.4 4.4 5.4 5.7 8.6 1.4 3.2 2.1 6.7 2.1 10.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    className: "s3",
    d: "m37.5 43.7q-0.1-0.1-0.3-0.3-0.1-0.1-0.2-0.3-0.1-0.2-0.1-0.3-0.1-0.2-0.2-0.4l-4.2 2.4q0.1 0.2 0.2 0.3 0.2 0.2 0.3 0.4 0 0.1 0.1 0.3 0.1 0.2 0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    className: "s3",
    d: "m30.3 56.2v-4.9q-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0.1-0.2 0.1-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1 0-0.2 0-0.1 0-0.2 0 0 0-0.1 0v4.9q0.1 0 0.1-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    className: "s3",
    d: "m50.6 51.3v4.9q0.1 0 0.2-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0.1 0.2 0.1v-4.9q-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0.1-0.2 0.1-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1 0-0.2 0-0.1 0-0.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    className: "s3",
    d: "m32.5 62.6l4.2 2.5q0.1-0.2 0.2-0.4 0-0.1 0.1-0.3 0.1-0.2 0.2-0.3 0.2-0.2 0.3-0.3l-4.2-2.5q-0.1 0.2-0.2 0.4-0.1 0.2-0.2 0.3-0.1 0.2-0.2 0.3-0.1 0.2-0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    className: "s3",
    d: "m43.4 63.8q0.2 0.1 0.3 0.3 0.1 0.1 0.2 0.3 0.1 0.2 0.2 0.3 0 0.2 0.1 0.4l4.2-2.5q-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3-0.1-0.2-0.1-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    className: "s3",
    d: "m43.4 43.7l4.3 2.4q0-0.1 0.1-0.3 0.1-0.2 0.2-0.3 0.1-0.2 0.2-0.4 0.1-0.1 0.2-0.3l-4.2-2.4q-0.1 0.2-0.2 0.4 0 0.1-0.1 0.3-0.1 0.2-0.2 0.3-0.2 0.2-0.3 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    className: "s3",
    d: "m40.5 63.9c-1 0-1.9 0.6-2.3 1.6-0.4 0.9-0.2 1.9 0.5 2.6 0.7 0.7 1.8 0.9 2.7 0.5 0.9-0.3 1.5-1.2 1.5-2.2q0-0.5-0.2-0.9-0.2-0.5-0.5-0.8-0.4-0.4-0.8-0.6-0.5-0.2-0.9-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_60",
    className: "s3",
    d: "m40.5 43.5c-1.4 0-2.5-1-2.5-2.4 0-1.3 1.1-2.4 2.5-2.4 1.3 0 2.4 1.1 2.4 2.4 0 1.4-1.1 2.4-2.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    className: "s3",
    d: "m51.4 49.9c1 0 1.9-0.6 2.3-1.5 0.3-1 0.1-2-0.6-2.7-0.7-0.7-1.7-0.9-2.6-0.5-0.9 0.3-1.5 1.2-1.5 2.2q0 0.5 0.1 1 0.2 0.4 0.6 0.7 0.3 0.4 0.8 0.6 0.4 0.2 0.9 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    className: "s3",
    d: "m29.5 45c-1 0-1.9 0.6-2.2 1.5-0.4 0.9-0.2 1.9 0.5 2.6 0.7 0.7 1.7 1 2.7 0.6 0.9-0.4 1.5-1.3 1.5-2.3q0-0.5-0.2-0.9-0.2-0.5-0.6-0.8-0.3-0.4-0.7-0.5-0.5-0.2-1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    className: "s3",
    d: "m51.4 57.6c-1 0-1.9 0.6-2.3 1.5-0.3 0.9-0.1 2 0.6 2.7 0.7 0.7 1.7 0.9 2.6 0.5 1-0.4 1.5-1.3 1.5-2.3q0-0.4-0.1-0.9-0.2-0.4-0.6-0.8-0.3-0.3-0.8-0.5-0.4-0.2-0.9-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    className: "s3",
    d: "m29.5 57.6c-1 0-1.9 0.6-2.2 1.5-0.4 0.9-0.2 2 0.5 2.7 0.7 0.7 1.7 0.9 2.7 0.5 0.9-0.4 1.5-1.3 1.5-2.3q0-0.4-0.2-0.9-0.2-0.4-0.6-0.8-0.3-0.3-0.7-0.5-0.5-0.2-1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    className: "s3",
    d: "m34.6 49.4l5.9 3.1 5.8-3.1-5.8-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    className: "s3",
    d: "m47.1 57.6v-6.9l-5.9 3.1v7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    className: "s3",
    d: "m33.8 57.6l5.9 3.2v-7l-5.9-3.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi11);
export default __webpack_public_path__ + "static/media/ri11.9c602c2713b0b65fc191a9eb71a71248.svg";
export { ForwardRef as ReactComponent };